import { ComparateurFunnel } from '../../../components/tools/ComparateurFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('entreprises', 'comparateur-energie')!;

export default function EntreprisesComparateurEnergiePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/entreprises"
        backLabel="Espace entreprises"
        duration="3 min"
      >
        <ComparateurFunnel lockedAudience="entreprises" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace entreprises', url: 'https://solutionecofrance.fr/entreprises' },
          { name: 'Comparateur énergie', url: 'https://solutionecofrance.fr/entreprises/comparateur-energie' },
        ]}
      />
    </>
  );
}
